import Router from 'next/router';

export default (res, route) => {
  if (res) {
    res.redirect(301, route);
    res.finished = true;
  } else {
    Router.replace(route);
  }
};
